export enum TalentConversationLocation {
    Inbox = 'inbox',
    Archive = 'archive',
    Spam = 'spam',
}
